import { mapValues } from "lodash";
import { CustomValue, CustomValueMetaActionName, CustomValueState } from "PFTypes";
import { useMemo } from "react";

export const useSkillActionPermissions = (
  skill: CustomValue
): {
  isActionEnabledMap: Record<CustomValueMetaActionName, boolean>;
  isActionDisabledMap: Record<CustomValueMetaActionName, boolean>;
  isGlobalSkill: boolean;
} => {
  const isGlobalSkill = skill.globalId !== null && skill.global_id !== null;

  const isMerged = skill.state === CustomValueState.Merged;

  const isEditionAllowed = !isGlobalSkill && skill.state !== CustomValueState.Blocked;

  const isBlocked = skill.state === CustomValueState.Blocked;

  const isActionEnabledMap = useMemo(
    () => ({
      approve: skill.state !== CustomValueState.Approved && !isMerged,
      block: !isBlocked && !isMerged,
      edit: isEditionAllowed,
      export: true,
      merge: isEditionAllowed && !isMerged,
      reset: !isGlobalSkill || isBlocked
    }),
    [isBlocked, isEditionAllowed, isGlobalSkill, isMerged, skill.state]
  );

  return {
    isActionEnabledMap,
    isActionDisabledMap: useMemo(
      () => mapValues(isActionEnabledMap, (enabled) => !enabled),
      [isActionEnabledMap]
    ),
    isGlobalSkill
  };
};
